var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"btn-control",class:{ disabled: _vm.disabled }},_vm.$listeners),[_c('i',{staticClass:"fas fa-plus-circle text-white-50"})])
}
var staticRenderFns = []

export { render, staticRenderFns }